<template>
    <div class="container banner row justify-center items-center image" v-if="img">
        <v-img :item="item" :img="img" :key="img.url"></v-img>
    </div>
</template>

<script>
    export default {
        name: 'VBanner',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Banner.vue